import React from "react";
import { clsx } from "clsx";
import { ChevronRight } from "lucide-react";

export interface BreadcrumbItem {
    label: string;
    href?: string;
    onClick?: () => void;
}

export interface BreadcrumbProps extends React.HTMLAttributes<HTMLElement> {
    items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className, ...props }) => (
    <nav aria-label="Breadcrumb" className={clsx("text-sm", className)} {...props}>
        <ol className="flex flex-wrap items-center gap-1 text-neutral-secondary">
            {items.map((item, i) => {
                const last = i === items.length - 1;
                return (
                    <li key={`${item.label}-${i}`} className="inline-flex items-center gap-1">
                        {i > 0 ? <ChevronRight size={14} aria-hidden className="opacity-50" /> : null}
                        {last || (!item.href && !item.onClick) ? (
                            <span className={clsx(last && "font-medium text-neutral-dark dark:text-white")} aria-current={last ? "page" : undefined}>
                                {item.label}
                            </span>
                        ) : item.href ? (
                            <a href={item.href} className="hover:text-primary hover:underline">
                                {item.label}
                            </a>
                        ) : (
                            <button type="button" onClick={item.onClick} className="hover:text-primary hover:underline">
                                {item.label}
                            </button>
                        )}
                    </li>
                );
            })}
        </ol>
    </nav>
);
